/**
 * @namespace
 * @global
 */
const Loading = {
	on: function (element) {
		$(element).parents('.loading-container').first().addClass('loading');
	},

	off: function (element) {
		$(element).parents('.loading-container').first().removeClass('loading');
	}
}